import { render, staticRenderFns } from "./EfficiencyReport.vue?vue&type=template&id=207b74b4&scoped=true&"
import script from "./EfficiencyReport.vue?vue&type=script&lang=js&"
export * from "./EfficiencyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207b74b4",
  null
  
)

export default component.exports